<script setup lang="ts">
    import { computed } from 'vue'
    import { ErrorData, getViolationsFeedback } from '@/js/utils'

    const emit = defineEmits(['update:modelValue', 'change'])

    export interface Props {
        modelValue: string | null | undefined
        items: any[]
        label?: string
        hint?: string
        placeholder?: string
        itemValue?: string
        itemTitle?: string
        dataTest?: string
        error?: ErrorData
        violationFields?: string[]
        isLoading?: boolean
        disabled?: boolean
    }

    const props = withDefaults(defineProps<Props>(), {
        label: '',
        hint: '',
        placeholder: '',
        itemTitle: 'title',
        itemValue: 'value',
        violationFields: () => [] as string[],
        dataTest: '',
        error: () => {
            return {} as ErrorData
        },
        isLoading: false,
        disabled: false
    })

    const value = computed({
        get: () => props.modelValue,
        set: (val) => {
            emit('update:modelValue', val ?? '')
            emit('change', val ?? '')
        }
    })

    const errorMessages = computed(() => {
        return props.error ? getViolationsFeedback(props.violationFields, props.error) : ''
    })
</script>

<template>
    <v-select
        v-model="value"
        :label="label"
        :placeholder="placeholder"
        :data-test="dataTest"
        :items="items"
        :item-value="itemValue"
        :item-title="itemTitle"
        :disabled="isLoading || disabled"
        variant="outlined"
        class="text-primary"
        density="compact"
        :hint="hint"
        :hide-details="!hint && !errorMessages?.length"
        :error-messages="errorMessages"
        :error="!!errorMessages?.length"
    />
</template>

<style scoped></style>
